import { useDashboardStore } from '../useDashboardStore';
import { cn } from '@/lib/cn';

export default function QuickNotes() {
  const notes = useDashboardStore((s) => s.notes);
  const setNotes = useDashboardStore((s) => s.setNotes);

  return (
    <textarea
      value={notes}
      onChange={(e) => setNotes(e.target.value)}
      placeholder="Jot something down…"
      rows={7}
      className={cn(
        'w-full resize-none rounded-lg border border-gray-200 bg-gray-50 p-3',
        'text-sm text-gray-900 placeholder-gray-400',
        'transition-all duration-200 ease-in-out',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:border-indigo-300',
      )}
      aria-label="Quick notes"
    />
  );
}
